import {Module} from "vuex";
import {ToasterConfig, ToasterConfigUpdate} from "@/types/ToasterConfig";

const toasterModule: Module<any, any> = {
  state: {
    toaster: {
      type: 'green',
      message: "",
      secondMessage: [],
      isVisible: false,
      visibleOnNextPage: false,
    } as ToasterConfig,
  },
  getters: {},
  mutations: {
    updateToaster(state, config: ToasterConfigUpdate) {
      state.toaster.type = config.type;
      state.toaster.message = config.message;
      state.toaster.secondMessage = (config.secondMessage) ? config.secondMessage : [];
      state.toaster.isVisible = (config.isVisible) ? config.isVisible : true;
      state.toaster.visibleOnNextPage = (config.visibleOnNextPage) ? config.visibleOnNextPage : false;
    },
    removeToaster(state) {
      state.toaster.type = 'green';
      state.toaster.message = "";
      state.toaster.secondMessage = [];
      state.toaster.isVisible = false;
      state.toaster.visibleOnNextPage = false;
    },
    visibleOnThisPage(state) {
      state.toaster.visibleOnNextPage = false;
      state.toaster.isVisible = true;
    },
  },
  actions: {},
};

export default toasterModule;
